module.exports = __webpack_public_path__ + "static/media/hiw3yellow.d2ba04b9.svg";